// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19dUG","colBig":"styles_colBig__3-Sbr","colSmall":"styles_colSmall__5XXcs"};